var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconImage)?_c('img',{attrs:{"src":'/img/icons/' + _vm.iconImage,"alt":"No status ico"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }